import React from 'react';
import { FormGroup, Button, ControlLabel, HelpBlock } from 'react-bootstrap';
import update from 'immutability-helper';

import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

import Select from 'react-select';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import Stars from '../../../components/Stars/Stars';

const Handle = Slider.Handle;

const display2Decimal = value => {
  return value;
};
const handle = props => {
  const { value, dragging, index } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={display2Decimal(value)}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...props} />
    </Tooltip>
  );
};

const brandsByParent = brand => {
  if (brand === 'bestwestern') {
    return [915, 913, 910, 912, 914, 916, 911];
  }
  if (brand === 'choice') {
    return [927, 928, 1122, 929, 931, 934, 930, 1086, 932, 933, 1105, 935];
  }
  if (brand === 'hilton') {
    return [959, 956, 960, 958, 961, 966, 957, 962, 964, 963, 965, 955];
  }
  if (brand === 'hyatt') {
    return [1092, 974, 978, 977, 980, 979, 976, 973];
  }
  if (brand === 'ihg') {
    return [991, 983, 986, 989, 990, 988, 985, 982, 984, 987];
  }
  if (brand === 'radisson') {
    return [925, 924, 922, 919, 921, 920, 923];
  }
  if (brand === 'marriott') {
    return [
      1012,
      1008,
      1003,
      1013,
      1009,
      1004,
      1017,
      1011,
      1005,
      1007,
      1010,
      1016,
      1018,
      1006,
      1015,
      1014,
      1019,
    ];
  }

  if (brand === 'starwood') {
    return [1030, 1024, 1031, 1029, 1026, 1022, 1002, 1027, 1021, 1028, 1025, 1023];
  }
  return [];
};

class HotelSearchPrefsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: this.props.prefs.brands,
      distance: this.props.prefs.distance,
      stars: this.props.prefs.stars,
      save: false,
    };
    if (this.props.prefs.stars) {
      this.state = {
        brands: this.props.prefs.brands,
        distance: this.props.prefs.distance,
        stars: this.props.prefs.stars,
        save: false,
      };
    } else {
      this.state = {
        brands: this.props.prefs.brands,
        distance: this.props.prefs.distance,
        stars: { lower: 0, upper: 0 },
        save: false,
      };
    }
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.handleDistanceChange = this.handleDistanceChange.bind(this);
    this.handleStarsChange = this.handleStarsChange.bind(this);
    this.savePreferences = this.savePreferences.bind(this);
  }
  handleBrandChange(brands) {
    const brandIds = brands.map(brand => brand.value);
    this.setState({
      brands: brandIds,
      save: true,
    });
  }
  handleDistanceChange(value) {
    this.setState({
      distance: value,
      save: true,
    });
  }
  handleStarsChange(value) {
    this.setState({
      stars: { lower: value.lower, upper: value.upper, bounds: '[)' },
      save: true,
    });
  }
  savePreferences(e) {
    e.preventDefault();
    const pref = {
      brands: this.state.brands,
      distance: this.state.distance,
      stars: this.state.stars,
      has_search_prefs: true,
    };
    this.props.savePreferences(this.props.id, pref);
    this.setState({
      save: false,
    });
    this.props.onClose();
  }
  quickAdd(brand) {
    const brands = update(this.state.brands, { $push: brandsByParent(brand) });
    this.setState({
      brands,
      save: true,
    });
  }

  render() {
    const showDistance = true;
    return (
      <div>
        <div className="spacing brand-picker">
          <FormGroup controlId="brands">
            <ControlLabel>Brands</ControlLabel>
            <Select
              name="brand"
              value={this.state.brands}
              options={this.props.brandList}
              onChange={this.handleBrandChange}
              multi
              joinValues
            />
            <HelpBlock>
              Select hotels brands you are interested in getting pricing from.
              <br />Quickly add hotels by family of brand{' '}
              <a
                onClick={() => {
                  this.quickAdd('bestwestern');
                }}
              >
                Best Western
              </a>,{' '}
              <a
                onClick={() => {
                  this.quickAdd('choice');
                }}
              >
                Choice
              </a>,{' '}
              <a
                onClick={() => {
                  this.quickAdd('hilton');
                }}
              >
                Hilton
              </a>,{' '}
              <a
                onClick={() => {
                  this.quickAdd('hyatt');
                }}
              >
                Hyatt
              </a>,{' '}
              <a
                onClick={() => {
                  this.quickAdd('ihg');
                }}
              >
                IHG
              </a>{' '}
              ,
              <a
                onClick={() => {
                  this.quickAdd('marriott');
                }}
              >
                Marriott
              </a>,{' '}
              <a
                onClick={() => {
                  this.quickAdd('radisson');
                }}
              >
                Radisson
              </a>, or{' '}
              <a
                onClick={() => {
                  this.quickAdd('starwood');
                }}
              >
                Starwood
              </a>,{' '}
            </HelpBlock>
          </FormGroup>
          {showDistance && (
            <FormGroup controlId="distance">
              <ControlLabel>Distance</ControlLabel>
              <p className="pull-right">
                {this.state.distance.toFixed(0)} km / {(this.state.distance * 0.621371).toFixed(0)}{' '}
                miles
              </p>
              <Slider
                value={this.state.distance}
                min={5}
                max={300}
                step={5}
                handle={handle}
                onChange={this.handleDistanceChange}
              />
              <HelpBlock>Search distance from the venue.</HelpBlock>
            </FormGroup>
          )}
          <FormGroup controlId="stars">
            <ControlLabel>Hotel Rating</ControlLabel>
            {this.state.stars.lower > 0 && (
              <p>
                Search includes hotels between {this.state.stars.lower} and{' '}
                {this.state.stars.upper - 1} stars.
              </p>
            )}
            {!this.state.stars.lower && <p>Star filter is cleared.</p>}
            <Stars value={this.state.stars} count={5} onChange={this.handleStarsChange} />

            <HelpBlock>Filter hotels based on their AAA rating.</HelpBlock>
          </FormGroup>
          <div className="clearfix" />
        </div>
        {this.state.save && (
          <div className="spacing info-panel">
            <Button onClick={this.savePreferences} bsStyle="primary">
              <i className="fa fa-floppy-o" /> Save
            </Button>
          </div>
        )}
      </div>
    );
  }
}

HotelSearchPrefsForm.propTypes = {
  id: PropTypes.number.isRequired,
  brandList: PropTypes.arrayOf(PropTypes.object).isRequired,
  prefs: PropTypes.shape({
    brands: PropTypes.arrayOf(PropTypes.number),
    distance: PropTypes.number,
    stars: PropTypes.object,
    queens: PropTypes.number,
    kings: PropTypes.number,
    suites: PropTypes.number,
  }).isRequired,
  savePreferences: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

HotelSearchPrefsForm.defaultProps = {
  brandList: [],
};

export default HotelSearchPrefsForm;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefsForm.js